<template>
  <div class="todo-list">
    <div @click="handleTodo">
      你有待处理的通话小结，请及时去处理
      <img class="icon" :src="arrow" />
    </div>
    <CallRecord ref="CallRecordRef" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import arrow from '@/assets/img/arrow.png'
import CallRecord from './components/CallRecord.vue'

const CallRecordRef = ref(null)

const handleTodo = () => {
  CallRecordRef.value.visible = true
}
</script>

<style scoped lang="scss">
.todo-list {
  padding: 9px 12px;
  background-color: #fff5ea;
  font-weight: 400;
  font-size: 14px;
  color: #ff9008;
  cursor: pointer;
  .icon {
    width: 18px;
    height: 18px;
  }
}
</style>
